// Чистая (framework-free) логика брендирования страниц входа/регистрации.
// Вынесена из BrandLogo.vue, чтобы её можно было юнит-тестировать на node:test
// без Vue-рантайма (см. test/authBranding.test.js). В репозитории нет тестового
// фреймворка — используется только встроенный node:test (CommonJS-экспорт, как
// в src/utils/githubOAuth.js).
//
// Theme is selected at build time; the runtime name never changes the theme.

// Бренд, для которого кабинет ребрендирован в Zentrolink.
const ZENTROLINK_BRAND = 'Zentrolink';
function getRuntimeBrand() {
    if (typeof window === 'undefined' || !window.__PROCESSING_BRAND__) {
        throw new Error('runtime brand snapshot is unavailable');
    }
    return window.__PROCESSING_BRAND__;
}

// Как рисовать логотип бренда в шапке форм входа/регистрации.
// Только Zentrolink получает runtime wordmark;
// для всех прочих брендов, включая Graphite (24.10.2026, без noderemit по умолчанию), возвращаем image —
// BrandLogo.vue рисует <img> из store.logo, как и раньше.
function resolveBrandLogo(individual) {
    if (individual === ZENTROLINK_BRAND) {
        return { kind: 'wordmark', text: getRuntimeBrand().name };
    }
    return { kind: 'image' };
}

// --- WCAG-контраст ---------------------------------------------------------
// Нужен, чтобы тест мог доказать: фирменный акцент авторизации соответствует
// WCAG 2.1 AA для обычного текста (≥ 4.5:1) на белом фоне. Акцент используется
// и как фон CTA-кнопок (белый текст на акценте), и как цвет ссылок/текста на
// белом; контраст симметричен, поэтому одного порога 4.5:1 достаточно для обеих
// ролей. Формула — WCAG relative luminance.

// AA-порог контраста для обычного текста.
const WCAG_AA_NORMAL = 4.5;

function _srgbChannel(value8bit) {
    const c = value8bit / 255;
    return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
}

// Относительная яркость sRGB-цвета в формате '#rrggbb' (регистр не важен).
function relativeLuminance(hex) {
    const m = /^#?([0-9a-fA-F]{6})$/.exec(String(hex).trim());
    if (!m) throw new Error(`relativeLuminance: некорректный hex-цвет: ${hex}`);
    const int = parseInt(m[1], 16);
    const r = (int >> 16) & 0xff;
    const g = (int >> 8) & 0xff;
    const b = int & 0xff;
    return 0.2126 * _srgbChannel(r) + 0.7152 * _srgbChannel(g) + 0.0722 * _srgbChannel(b);
}

// Коэффициент контраста между двумя цветами (симметричен; ≥ 1).
function contrastRatio(hexA, hexB) {
    const la = relativeLuminance(hexA);
    const lb = relativeLuminance(hexB);
    const hi = Math.max(la, lb);
    const lo = Math.min(la, lb);
    return (hi + 0.05) / (lo + 0.05);
}

module.exports = {
    ZENTROLINK_BRAND,
    getRuntimeBrand,
    resolveBrandLogo,
    relativeLuminance,
    contrastRatio,
    WCAG_AA_NORMAL,
};
